/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Repair_QuoteInputs */

const en_case_doc_repair_quote = /** @type {(inputs: Case_Doc_Repair_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailed repair estimate(s)`)
};

const pt_br2_case_doc_repair_quote = /** @type {(inputs: Case_Doc_Repair_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orçamento(s) detalhado reparo`)
};

/**
* | output |
* | --- |
* | "Detailed repair estimate(s)" |
*
* @param {Case_Doc_Repair_QuoteInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_repair_quote = /** @type {((inputs?: Case_Doc_Repair_QuoteInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Repair_QuoteInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_repair_quote(inputs)
	return pt_br2_case_doc_repair_quote(inputs)
});